import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'mysqlDate',
  pure: false
})
export class MysqlDatePipe implements PipeTransform {
  // returns date in format 2019-11-29 11:31:20
  constructor(private translate: TranslateService) {}
    transform(longDate: any, ...args: any[]): string {
     
      if (!longDate || longDate === 0) {
        return this.translate.instant('--');
      }
    
    const dateObj = new Date(longDate);
    
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0'); 
    const day = String(dateObj.getDate()).padStart(2, '0');
    const hours = String(dateObj.getHours()).padStart(2, '0');
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const seconds = String(dateObj.getSeconds()).padStart(2, '0');
    
    const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    
    return formattedDateTime;

    // return new Date(longDate).toLocaleString();
  }

}
@Pipe({
  name: 'dateOfBirth'
})
export class DateOfBirthPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}
  transform(longDate: any, ...args: any[]): string {
    const date = new Date(Number(longDate));
    if (longDate === 0) {
      return this.translate.instant('-');
    }

    return new Date(longDate).toISOString().split('T')[0];
  }

}
